import styled, { keyframes } from 'styled-components';

const moveDownKeyframe = keyframes`
  from {top:30px; opacity: 0;}
  to {top:43px; opacity: 1}
`;

export const BadgeDropdownContainer = styled.div`
  position: relative;
  padding-left: 16px;
  margin-right: 5px;

  .arrow {
    border-style: solid;
    box-sizing: border-box;
    height: 5px;
    width: 5px;
    border-color: #979797;
    border-width: 0px 1px 1px 0px;
    transform: rotate(45deg);
    margin: 16px 15px 15px 7px;
    cursor: pointer;
  }

  .tooltip-dropdown {
    list-style: none;
    margin: 0;
    padding: 0;
    display: none;
    position: absolute;
    top: 71px;
    right: 11px;
    z-index: 1000;
    background: white;
    -moz-border-radius: 5px;
    border-radius: 4px;
    width: 118px !important;
    min-height: 70px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.15);
    border: 0;
    border-top: 1px #ebeef0 solid;
    background-color: #ffffff;
  }
  .badge:hover,
  .arrow-hover {
    cursor: pointer;
  }
  .badge-container:hover > ul {
    display: block;
  }
  .tooltip-dropdown li {
    float: none;
    margin: 0;
    padding: 0;
    display: block;
  }
  .tooltip-dropdown li a {
    height: auto;
    line-height: 1;
    display: block;
    white-space: nowrap;
    float: none;
    text-transform: none;
    font-size: 12px;
    font-weight: 600;
    color: #585858;
  }
  .tooltip-dropdown li:first-child {
    border-top: solid 0.5px #d5d5d5;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .tooltip-dropdown li:last-child {
    border-bottom: solid 0.5px #d5d5d5;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .tooltip-dropdown li {
    border-left: solid 0.5px #d5d5d5;
    border-right: solid 0.5px #d5d5d5;
  }
  .tooltip-dropdown li:hover {
    background-color: #f0f0f0;
  }
  .tooltip-dropdown li:first-child a {
    -moz-border-radius: 5px 5px 0 0;
    -webkit-border-radius: 5px 5px 0 0;
    border-radius: 5px 5px 0 0;
  }
  .tooltip-dropdown li:first-child a:after {
    content: '';
    position: absolute;
    right: 30px;
    top: -8px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid #f0f0f0;
  }

  .badge-container:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: ' ';
    clear: both;
    height: 0;
  }
  button:focus,
  input:focus,
  select:focus {
    outline: 0;
  }
  button:focus,
  button:hover {
    cursor: pointer;
  }
  .app-icon {
    fill: #183247;
    margin-right: -2px;
    width: 14px;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }

  .badge-icon {
    background-color: var(--color-elephant-600);
    color: #ffffff;
    margin-right: 5px;
    line-height: 32px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    user-select: none;
    padding: 8px 11px;
    border-radius: 3px;
    min-width: 32px;
  }

  .badge-container .arrow {
    visibility: hidden;
  }

  .droplist-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1080;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    background-color: #fff;
    display: none;
    user-select: none;
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;
    backface-visibility: hidden;
  }

  .droplist-menu.dropdown-menu--open {
    display: block;
    z-index: 1;
  }

  .profile-dropdown::after,
  .profile-dropdown::before {
    bottom: 100%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
  }

  .profile-dropdown:before {
    border-color: rgba(229, 229, 229, 0);
    border-bottom-color: #ebeef0;
    border-width: 6px;
    margin-left: -6px;
    right: 14px;
  }
  .profile-dropdown::after {
    border-color: rgba(211, 219, 218, 0);
    border-bottom-color: #f9f9f9;
    border-width: 5px;
    margin-left: -5px;
    right: 15px;
  }
  .profile-dropdown {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.15);
    border: 0;
    padding: 0;
    min-width: 180px;
    top: 42px;
    right: 5px;
    left: auto;
    border-radius: 2px;
    border-top: 1px #ebeef0 solid;
    text-align: center;
    z-index: -1;
    animation: ${moveDownKeyframe} 0.3s ease 0s 1 normal forwards running;
  }

  .text--semibold {
    font-weight: 500;
    font-size: 14px;
    line-height: 2;
  }
  .text__infotext {
    font-size: 13px;
    color: #6f7c87;
  }
  .profile-dropdown .text__infotext {
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  .profile-dropdown.droplist-menu > a:hover {
    background-color: #f3f5f7;
  }
  .profile-dropdown__item {
    border-bottom: 1px #f2f2f2 solid;
    background-color: #fff;
    padding: 10px 15px;
    border-radius: 2px;
    margin: 0;
    color: #183247;
    display: block;
    line-height: 1.42857;
    white-space: nowrap;
    text-decoration: none;
    text-align: center;
  }

  text__content {
    color: #183247;
    margin: 0;
    padding: 0;
  }
  .profile-dropdown__item.profile-dropdown__textitem {
    background-color: #f9f9f9;
    border-radius: 2px 2px 0 0;
    line-height: 1.42857;
    padding: 10px 15px;
  }

  .userprofile-loader .react-loading-skeleton {
    height: 30px;
    margin-left: 20px;
  }
`;
